import { getTrainingProgramsInfo } from 'core/contexts/training-programs/api/api';
import { TrainingProgramInfo } from 'core/contexts/training-programs/domain';
import { updateQuery } from 'core/query-client/query-client';
import { QUERY_KEYS } from 'core/query-client/query-keys.constants';
import { executeRequest } from 'core/utils/backend-service';
import { useCallback } from 'react';
import { usePocQuery } from './use-poc-query.hook';

export type UseTrainingProgramsInfoResult = {
    trainingProgramsInfo: TrainingProgramInfo[];
    isLoading: boolean;
    refreshTrainingProgramsInfo: () => Promise<void>;
};

export const useTrainingProgramsInfo = (): UseTrainingProgramsInfoResult => {
    const { data: trainingProgramsInfo = [], isLoading } = usePocQuery({
        queryKey: QUERY_KEYS.TRAINING_PROGRAMS_INFO,
        queryFn: () => executeRequest(() => getTrainingProgramsInfo()),
    });

    const refreshTrainingProgramsInfo = useCallback(() => updateQuery(QUERY_KEYS.TRAINING_PROGRAMS_INFO), []);

    return {
        trainingProgramsInfo,
        isLoading,
        refreshTrainingProgramsInfo,
    };
};
